module.exports = __webpack_public_path__ + "static/media/about2.7c1b1c4a.jpg";